// import {
//   IStyle,
//   ITheme,
// } from '../../Styling';
export var getStyles = function (props) {
    var className = props.className
    // theme,
    ;
    // const { palette, semanticColors } = theme;
    return {
        root: [
            'ms-ContextualMenuItem',
            {
            // Insert css properties
            },
            className
        ]
        // Insert className styles
    };
};
//# sourceMappingURL=ContextualMenuItem.styles.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/components/ContextualMenu/ContextualMenuItem.styles.js
// module id = 206
// module chunks = 0